export default "/images/45ffb2672dba0c99874cc661f6bba7a1.avif";